
import { Component, Prop, Mixins, Watch } from "vue-property-decorator";
import FormValidator from "@/mixins/FormValidator";
import FormCard from "@/components/FormCard.vue";
interface requestData {
  document_type: string | number;
  document_id: string;
  ticket_number: string;
}

@Component({
  components: {
    FormCard
  }
})
export default class RequestDetailFormNew extends Mixins(FormValidator) {
  private base_bucket = process.env.VUE_APP_AWS_ASSETS;
  private id_comuna = process.env.VUE_APP_ID_COMUNA as string;
  protected formData: requestData = {
    document_type: "1",
    document_id: "",
    ticket_number: ""
  };

  options_document: object[] = [
    { label: "DNI", value: "0" },
    { label: "RUT", value: "1" },
    { label: "Pasaporte", value: "2" }
  ];

  private mounted() {}

  formIsTicketNumber(value: string) {
    if (/^([0-9]+-[0-9]+)$|^[0-9]+$/g.test(value)) {
      return true;
    }
    return this.$t("El número del ticket no es válido");
  }

  private consultarTicket() {
    this.$router.push({
      name: "requestdetailsnew",
      params: {
        id_ticket: this.formData.ticket_number,
        rut: this.formData.document_id,
        tipo_doc: String(this.formData.document_type)
      }
    });
  }
}
